const getListImage = (id) => require(`../Images/blog/list/${id}.jpg`);
const getBannerImage = (id) => require(`../Images/blog/banner/${id}.jpg`);

const BlogData = [
  {
    id: 1,
    title: "Catering Like the Stars: Hyderabad’s Most Exclusive Menus Unveiled",
    content : [
    {
      type: "paragraph",
      text: "When you think of grand celebrations in Hyderabad, the first thing that comes to mind—apart from flamboyant décor—is the food. In a city where luxury and tradition merge, high-end catering services have transitioned from a utility function; they're the showstopper. From Hollywood-style wedding receptions to swanky VIP parties, the need for upscale catering has never been stronger — where food is not just consumed but served, decorated, and relished like art."
    },
    {
      type: "heading",
      text: "The Era of Elite Catering in Hyderabad"
    },
    {
      type: "paragraph",
      text: "Hyderabad's catering industry has evolved a long way from set menus to gourmet, chef-led affairs. Luxury wedding caterers and high-end event planners now offer services on par with five-star hotels — all tailored to your event."
    },
    {
      type: "heading",
      text: "This is how they differ:"
    },
    {
      type: "list",
      items: [
        "Personalized menus created around your taste and event theme",
        "Multi-cuisine gourmet buffets, Japanese to Mediterranean",
        "Live cooking stations, sushi to pasta",
        "Handcrafted desserts served like a piece of art",
        "Luxurious, white-glove standard hospitality service"
      ]
    },
    {
      type: "paragraph",
      text: "Whatever the event — destination wedding in Hyderabad or intimate wedding in Jubilee Hills — clients want nothing short of five-star cuisine and that is exactly what these luxury caterers deliver."
    },
    {
      type: "heading",
      text: "How a Luxury Menu appears? Take a Peek"
    },
    {
      type: "paragraph",
      text: "Hyderabad's top luxury catering companies have anything-but-boring menus. These are not dishes — they're multi-sensory culinary experiences crafted by expert chefs. A sneak peek at what makes them stand out:"
    },
    {
      type: "list",
      items: [
        "Fusion Starters & Canapés",
        "Tartlets topped with caviar",
        "Beetroot carpaccio, feta snow",
        "Smoked salmon blinis",
        "Truffle mushroom bruschetta"
      ]
    },
    {
      type: "heading",
      text: "Signature Mains"
    },
    {
      type: "list",
      items: [
        "Lobster moilee with saffron rice",
        "Biryani infused with edible rose and gold leaf",
        "Millet risotto with smoked mushroom",
        "Wagyu sliders with aged cheddar"
      ]
    },
    {
      type: "heading",
      text: "Artful Desserts"
    },
    {
      type: "list",
      items: [
        "Liquid nitrogen kulfi",
        "Raspberry panna cotta domes",
        "Macaron towers in custom colours",
        "Deconstructed traditional Indian sweets"
      ]
    },
    {
      type: "paragraph",
      text: "These menus are normally bespoke-designed to reflect the event theme, the guests' palates, and the dietary limitations — vegan and gluten-free to Jain and keto."
    },
    {
      type: "heading",
      text: "What Makes It \"Celebrity-Worthy\"?"
    },
    {
      type: "paragraph",
      text: "The crème de la crème of Hyderabad catering services don't just serve guests food — they craft an experience. That is what leads them to do it"
    },
    {
      type: "list",
      items: [
        "Chef-Seared Experiences: Celebrity chefs are part of preparing each dish",
        "Visual Presentation: Plates are served as if art — Instagram-able at all tiers",
        "Ingredient Sourcing: Upscale, often international or organic, ingredients are used",
        "Luxury Touchpoints: Crystal table settings, to live music performed by artists at stations",
        "Personalization: Monogrammed plates, bespoke menu cards, and specially themed cocktail pairings"
      ]
    },
    {
      type: "paragraph",
      text: "This is top-tier catering at its finest — where the party feels like a gourmet restaurant only done for your guests."
    },
    {
      type: "heading",
      text: "When to Hire Exclusive Catering"
    },
    {
      type: "paragraph",
      text: "These upscale caterers are ideal for:"
    },
    {
      type: "list",
      items: [
        "Luxury destination events and weddings",
        "Black-tie corporate dinner galas and launches",
        "Private high-end parties and milestone family birthdays",
        "Private chefs' table dinner or VIP dinner",
        "Celebrity-level birthday extravaganzas"
      ]
    },
    {
      type: "paragraph",
      text: "No matter how many guests on your list — 50, 500 — upscale caterers provide luxury within any size constraint without sacrificing either quality or originality."
    },
    {
      type: "heading",
      text: "Eco-Lux & Conscious Catering: currently trending"
    },
    {
      type: "paragraph",
      text: "One of the new trends among the high-end caterers in Hyderabad is also the shift towards eco-luxury catering. Consider:"
    },
    {
      type: "list",
      items: [
        "Farm-to-table food",
        "Zero-waste menus",
        "Biodegradable serveware with luxury appearance",
        "Clean, minimalist presentation for conscious hosts"
      ]
    },
    {
      type: "paragraph",
      text: "These services prove you don't have to compromise on sustainability for sophistication — you can have both."
    },
    {
      type: "heading",
      text: "Final Thoughts"
    },
    {
      type: "paragraph",
      text: "If you want to stun guests with unforgettable culinary artistry, Hyderabad's premium catering services are second to none. From chef-designed menus to immersive experiences and attention to every opulent detail, they provide food that is truly star-quality."
    },
    {
      type: "paragraph",
      text: "For upscale events in Hyderabad, one thing's certain: the menu is not merely a part of the party — it's the party."
    }
  ],
    listImage: getListImage(1),
    bannerImage: getBannerImage(1),
    link: "/blogs/blog-inner"
  },
  {
    id: 2,
    title: "What Makes a Caterer Truly 'Luxury' in Hyderabad? Here's How to Spot the Difference",
    content : [
    {
        type: "paragraph",
        text: `When you think of grand celebrations in Hyderabad, the first thing that comes to mind—apart from flamboyant décor—is the food. In a city where luxury and tradition merge, high-end catering services have transitioned from an utility function; they're the showstopper. From Hollywood-style wedding receptions to swanky VIP parties, the need for upscale catering has never been stronger — where food is not just consumed but served, decorated, and relished like art.`
    },
    {
        type: "heading",
        text: "The Era of Elite Catering in Hyderabad"
    },
    {
        type: "paragraph",
        text: `Hyderabad's catering industry has evolved a long way from set menus to gourmet, chef-led affairs. Luxury wedding caterers and high-end event planners now offer services on par with five-star hotels — all tailored to your event.`
    },
    {
        type: "heading",
        text: "This is how they differ:"
    },
    {
        type: "list",
        items: [
        "Personalized menus created around your taste and event theme",
        "Multi-cuisine gourmet buffets, Japanese to Mediterranean",
        "Live cooking stations, sushi to pasta",
        "Handcrafted desserts served like a piece of art",
        "Luxurious, white-glove standard hospitality service"
        ]
    },
    {
        type: "paragraph",
        text: `Whatever the event — destination wedding in Hyderabad or intimate wedding in Jubilee Hills — clients want nothing short of five-star cuisine and that is exactly what these luxury caterers deliver.`
    },
    {
        type: "heading",
        text: "How a Luxury Menu appears? Take a Peek"
    },
    {
        type: "paragraph",
        text: `Hyderabad's top luxury catering companies have anything-but-boring menus. These are not dishes — they're multi-sensory culinary experiences crafted by expert chefs. A sneak peek at what makes them stand out:`
    },
    {
        type: "heading",
        text: "Fusion Starters & Canapés"
    },
    {
        type: "list",
        items: [
        "Tartlets topped with caviar",
        "Beetroot carpaccio, feta snow",
        "Smoked salmon blinis",
        "Truffle mushroom bruschetta"
        ]
    },
    {
        type: "heading",
        text: "Signature Mains"
    },
    {
        type: "list",
        items: [
        "Lobster moilee with saffron rice",
        "Biryani infused with edible rose and gold leaf",
        "Millet risotto with smoked mushroom",
        "Wagyu sliders with aged cheddar"
        ]
    },
    {
        type: "heading",
        text: "Artful Desserts"
    },
    {
        type: "list",
        items: [
        "Liquid nitrogen kulfi",
        "Raspberry panna cotta domes",
        "Macaron towers in custom colours",
        "Deconstructed traditional Indian sweets"
        ]
    },
    {
        type: "paragraph",
        text: `These menus are normally bespoke-designed to reflect the event theme, the guests' palates, and the dietary limitations — vegan and gluten-free to Jain and keto.`
    },
    {
        type: "heading",
        text: `What Makes It "Celebrity-Worthy"?`
    },
    {
        type: "paragraph",
        text: `The crème de la crème of Hyderabad catering services don't just serve guests food — they craft an experience. That is what leads them to do it`
    },
    {
        type: "list",
        items: [
        "Chef-Seared Experiences: Celebrity chefs are part of preparing each dish",
        "Visual Presentation: Plates are served as if art — Instagram-able at all tiers",
        "Ingredient Sourcing: Upscale, often international or organic, ingredients are used",
        "Luxury Touchpoints: Crystal table settings, to live music performed by artists at stations",
        "Personalization: Monogrammed plates, bespoke menu cards, and specially themed cocktail pairings"
        ]
    },
    {
        type: "paragraph",
        text: `This is top-tier catering at its finest — where the party feels like a gourmet restaurant only done for your guests.`
    },
    {
        type: "heading",
        text: "When to Hire Exclusive Catering"
    },
    {
        type: "paragraph",
        text: `These upscale caterers are ideal for:`
    },
    {
        type: "list",
        items: [
        "Luxury destination events and weddings",
        "Black-tie corporate dinner galas and launches",
        "Private high-end parties and milestone family birthdays",
        "Private chefs' table dinner or VIP dinner",
        "Celebrity-level birthday extravaganzas"
        ]
    },
    {
        type: "paragraph",
        text: `No matter how many guests on your list -- 50, 500 -- upscale caterers provide luxury within any size constraint without sacrificing either quality or originality.`
    },
    {
        type: "heading",
        text: "Eco-Lux & Conscious Catering: currently tending."
    },
    {
        type: "paragraph",
        text: `One of the new trends among the high-end caterers in Hyderabad is also the shift towards eco-luxury catering. Consider:`
    },
    {
        type: "list",
        items: [
        "Farm-to-table food",
        "Zero-waste menus",
        "Biodegradable serveware with luxury appearance",
        "Clean, minimalist presentation for conscious hosts"
        ]
    },
    {
        type: "paragraph",
        text: `These services prove you don't have to compromise on sustainability for sophistication — you can have both.`
    },
    {
        type: "heading",
        text: "Final Thoughts"
    },
    {
        type: "paragraph",
        text: `If you want to stun guests with unforgettable culinary artistry, Hyderabad's premium catering services are second to none. From chef-designed menus to immersive experiences and attention to every opulent detail, they provide food that is truly star-quality.`
    },
    {
        type: "paragraph",
        text: `For upscale events in Hyderabad, one thing's certain: the menu is not merely a part of the party — it's the party.`
    }
    ],
    listImage: getListImage(2),
    bannerImage: getBannerImage(2),
    link: "/blogs/blog-inner"
  },
  {
    id: 3,
    title: "Small Bites, Big Impressions: Premium Appetizers That Steal the Show",
    content : [
    {
        type: "paragraph",
        text: `In luxury catering, the appetizer course is the prelude to what your guests will experience — sophistication, creativity, and lingering flavors. While entrées ground the menu, it is the small plates that add interest and conversation. Whether it's a decadent wedding or high-end corporate function, luxury appetizers are your secret weapon for impressing every single guest on your first bite.`
    },
    {
        type: "paragraph",
        text: `At Sri Maha, we don't think appetizers must simply be finger foods — they can and ought to be edible works of art.`
    },
    {
        type: "heading",
        text: "Why Appetizers Matter at High-End Events"
    },
    {
        type: "paragraph",
        text: `Appetizers are the introductory taste of your party's culinary adventure. They provide your guests with a preview of the quality, creativity, and sophistication your catering staff has in store for them. With upscale catering, it's not merely about nourishing your guests — it's about bringing pleasure and delight moments.`
    },
    {
        type: "paragraph",
        text: `Passed by servers or elegantly arranged on a grazing table, the proper appetizers can:`
    },
    {
        type: "list",
        items: [
        "Establish the mood for the event",
        "Elicit guest interaction",
        "Pair with mocktails and cocktails",
        "Make a lasting impression prior to the main course"
        ]
    },
    {
        type: "heading",
        text: "Our Top Selling Sophisticated Appetizers"
    },
    {
        type: "paragraph",
        text: `Claim as follows some signature bites never fail to steal the focus in our events:`
    },
    {
        type: "list",
        items: [
        "Truffle Mushroom Arancini — Golden-fried risotto balls infused with parmesan and truffle oil, served along with a saffron aioli. Ideal for reception lounges and cocktail receptions.",
        "Prawn Cocktail Bites served in Mini Martini Glasses — A taste- and visual-impression spin on the traditional prawn cocktail, presented in trendy mini glasses for that luxury feel.",
        "Brie & Fig Tartlets — Warm brie and fig jam between buttery puff pastry with a sprinkle of thyme. A winter wedding reception and cozy, intimate party classic.",
        "Cucumber Cups with Spiced Chickpea Mousse — A healthy, vegetarian-friendly choice that's as chic — ideal for afternoon soirees and wellness-focused events.",
        "Smoked Salmon Blinis with Dill Crème — Refined, beautiful, and timeless. These small morsels are ideal for black-tie events and themed canapé platters."
        ]
    },
    {
        type: "heading",
        text: "Presentation: First Impressions as Art"
    },
    {
        type: "paragraph",
        text: `Presentation is of utmost importance in high-end catering. Our appetizer platters are served with flair — with fine tableware, seasonal garnishes, and even edible flowers to add dramatic visual impact. We also have:`
    },
    {
        type: "list",
        items: [
        "Live counters for gourmet customization of appetizers",
        "Interactive theme-based grazing tables",
        "Custom plate designs for wedding or brand identity"
        ]
    },
    {
        type: "paragraph",
        text: `Every dish is carefully chosen to complement the overall look of your party — because, with small plates, details matter.`
    },
    {
        type: "heading",
        text: "Serving Suggestions by Party Type"
    },
    {
        type: "list",
        items: [
        "Weddings: Offer a combination of vegetarian and seafood dishes to cater to different tastes. Live canapé stations are a worthwhile option.",
        "Corporate Events: Refined, bite-sized hors d'oeuvres such as mini burgers, fusion skewers, and tartlets are ideal.",
        "Birthday Parties: Offer fun but elegant choices such as mini tacos, beetroot sliders, or spicy paneer pops."
        ]
    },
    {
        type: "heading",
        text: "Final Bite: Let Flavor Speak for You"
    },
    {
        type: "paragraph",
        text: `Appetizers aren't just the start — they're often what guests remember most. With the right luxury catering company, you can make small bites make a big impact. Whether you're having 50 or 500 guests, our handcrafted appetizers guarantee elegance, flavor, and long-lasting first impressions.`
    },
    {
        type: "paragraph",
        text: `Want to create an appetizer menu that captures the atmosphere of your event? Our chefs are ready to create a bite-to-die experience that your guests will be talking about.`
    },
    {
        type: "paragraph",
        text: `Luxury Catering | Sophisticated Small Plates, Big Flavor`
    },
    {
        type: "paragraph",
        text: `Hyderabad-based, we provide upscale wedding catering, corporate events, private dinner parties, and special events with an emphasis on memorable appetizers, mocktails, and gourmet bites. Schedule a consultation or tasting today.`
    }
    ],
    listImage: getListImage(3),
    bannerImage: getBannerImage(3),
    link: "/blogs/blog-inner"
  },
  {
    id: 4,
    title: "From Welcome Drinks to Signature Sips: Mocktails That Impress Every Guest",
    content : [
    {
        type: "paragraph",
        text: `When organizing a luxury event, all aspects count — from the menu to the decor to the beverages. One quite underrated aspect that can make a long-lasting impact on partygoers is the mocktail menu. Whether it is a wedding ceremony, corporate party, engagement party, or high-end birthday party, offering innovative, aesthetically pleasing, and delectable non-alcoholic drinks brings your event experience to the next level. As a high-end catering company, we take great care to create mocktails not only to taste delicious but also to complement your event theme and atmosphere.`
    },
    {
        type: "heading",
        text: "Why Mocktails Should Be in the Limelight"
    },
    {
        type: "paragraph",
        text: `Those afterthought mocktail days are done. They now happen with similar careful attention to and creativity that alcohol-based originals bring. Guests' inclusive drinks of choice are appreciated, especially on party platforms when not everybody will or even may consume booze. Personalized mocktails establish there is a level of forethought and get sophisticated, guest-crafted vibes under way. Your reception drink is the first taste your guests will have — make it memorable.`
    },
    {
        type: "list",
        items: [
        "Citrus Blossom Fizz: A fizzy, refreshing mocktail flavored with orange zest, lemongrass, and edible flowers. Perfect for beach weddings and daytime outdoor celebrations.",
        "Rose & Lychee Elixir: A scented and floral cocktail that is rich and refreshing at the same time — perfect for weddings, engagements, and formal sit-down affairs.",
        "Spiced Tamarind Cooler: A tribute to regional flavor, this cool but stinging drink is a hit at fusion-fun-fashion weddings and celebration-type festivities."
        ]
    },
    {
        type: "paragraph",
        text: `Not only will these drinks quench your guests' thirst, but they'll break the ice as well. They are beautifully served, in hip glassware, and sometimes garnished with herbs, fruit, or edible flowers — to match your event theme, of course.`
    },
    {
        type: "heading",
        text: "Signature Sips to Remember"
    },
    {
        type: "paragraph",
        text: `Every upscale party needs a signature mocktail — a drink that reflects your taste or brand personality.`
    },
    {
        type: "list",
        items: [
        "Lavender Lemonade Sparkler: Ideal for spring weddings or garden parties. Delicate lavender flavor with fresh lemon is a strange, calming experience.",
        "Mango Basil Cooler: Exotic, tropical flavor of a summer soiree favorite, company family day, or destination wedding.",
        "Smoked Berry Mule: Dark color with bold flavors — perfect for evening parties and sophisticated cocktail parties."
        ]
    },
    {
        type: "paragraph",
        text: `With every mocktail, we are committed to presentation, taste, and customization — so the drink enhances your party's atmosphere.`
    },
    {
        type: "heading",
        text: "Luxury Mocktail Catering"
    },
    {
        type: "paragraph",
        text: `At [Your Catering Brand Name], we set the bar higher for mocktail catering. We:`
    },
    {
        type: "list",
        items: [
        "Source seasonal ingredients for freshness and environmental sustainability.",
        "Customize mocktail bars with branding, signage, and festival-themed garnishes.",
        "Offer live mixology counters where guests can watch their drinks being crafted.",
        "Include glassware styling to enhance photography and create a luxury ambiance."
        ]
    },
    {
        type: "paragraph",
        text: `No matter if you're having a special soiree or giving a luxurious bash, we'd like your cocktails to be as legendary as your dish.`
    },
    {
        type: "heading",
        text: "Kick Any Party Up a Notch with Custom-Blended Libations"
    },
    {
        type: "paragraph",
        text: `Mocktails are not just booze-free beverages — they're a demonstration of hospitality, creativity, and detail. If made with love, they'll take your party to the next level and provide Instagram-perfect moments that your guests will be raving about long after the party is gone.`
    },
    {
        type: "paragraph",
        text: `Need to create a custom mocktail menu for your next event? Let's create something that won't be forgotten.`
    }
    ],
    listImage: getListImage(4),
    bannerImage: getBannerImage(4),
    link: "/blogs/blog-inner"
  }
];

export default BlogData;
